// Riwayat hasil latihan. Di Cloudflare: disimpan ke R2 lewat /api/riwayat (antre di
// perangkat bila offline, dikirim ulang saat online). Mode demo: disimpan di perangkat.
import { store } from '../core/storage.js';
import { S } from './state.js';

const ANTREAN = 'tka-antrean-riwayat';
const DEMO = 'tka-riwayat-demo';
export const MODE_DEMO = typeof __DEMO__ !== 'undefined' && __DEMO__;

const ringkas = (r, ekstra = {}) => ({ id: r.id, nama: r.nama, mapel: r.mapel, nilai: r.nilai, benar: r.benar, jumlah: r.soal.length, lulus: r.nilai >= r.batasLulus, durasiMs: r.durasiMs, selesai: r.selesai, ...ekstra });

function simpanLokal(kunci, r, maks) {
  const daftar = store.get(kunci, []).filter(x => x.id !== r.id);
  daftar.unshift(r);
  // localStorage terbatas (±5 MB), jadi buang yang paling lama bila penuh.
  for (let n = Math.min(maks, daftar.length); n > 0; n--) {
    try { localStorage.setItem(kunci, JSON.stringify(daftar.slice(0, n))); return true; } catch (e) { /* coba lebih sedikit */ }
  }
  return false;
}

async function kirim(r) {
  const res = await fetch('/api/riwayat', { method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json' }, body: JSON.stringify(r) });
  const d = await res.json().catch(() => ({}));
  return { res, d };
}

/** Simpan hasil latihan. @returns {Promise<{ok: boolean, id?: string, tertunda?: boolean, pesan?: string}>} */
export async function simpanRiwayat(r) {
  if (MODE_DEMO) {
    r.id = 'lokal-' + Date.now();
    return simpanLokal(DEMO, r, 12) ? { ok: true, id: r.id } : { ok: false, pesan: 'Penyimpanan perangkat penuh.' };
  }
  try {
    const { res, d } = await kirim(r);
    if (res.ok) { r.id = d.id; return { ok: true, id: d.id }; }
    if (res.status === 400 || res.status === 413) return { ok: false, pesan: d.pesan || 'Hasil latihan tidak bisa disimpan.' };
  } catch (e) { /* offline */ }
  r.id = 'antre-' + Date.now();
  r.akun = S.akun;
  simpanLokal(ANTREAN, r, 6);
  return { ok: false, tertunda: true };
}

// Antrean lama (sebelum ada akun) dicocokkan lewat nama.
const milikSaya = x => (x.akun ? x.akun === S.akun : x.nama === S.nama);

// Kirim ulang hasil latihan yang tertunda (dipanggil saat online dan setelah login).
export async function kirimAntrean() {
  if (MODE_DEMO) return 0;
  let terkirim = 0;
  // Hanya kirim milik akun yang sedang login (perangkat bisa dipakai bergantian).
  for (const r of store.get(ANTREAN, []).filter(milikSaya).reverse()) {
    try {
      const { res } = await kirim({ ...r, id: undefined });
      if (!res.ok && res.status !== 400 && res.status !== 413) break;
      const sisa = store.get(ANTREAN, []).filter(x => x.id !== r.id);
      store.set(ANTREAN, sisa);
      if (res.ok) terkirim++;
    } catch (e) { break; }
  }
  return terkirim;
}

/** Daftar ringkas, terbaru dulu. @returns {Promise<{riwayat: object[], offline?: boolean}>} */
export async function daftarRiwayat(mapel) {
  const cocok = x => !mapel || x.mapel === mapel;
  if (MODE_DEMO) return { riwayat: store.get(DEMO, []).filter(r => r.nama === S.nama).map(r => ringkas(r)).filter(cocok) };
  const antre = store.get(ANTREAN, []).filter(milikSaya).map(r => ringkas(r, { tertunda: true }));
  try {
    const res = await fetch('/api/riwayat?batas=50', { credentials: 'same-origin' });
    const d = await res.json();
    if (!res.ok) throw new Error(d.pesan);
    return { riwayat: [...antre, ...d.riwayat].filter(cocok) };
  } catch (e) {
    return { riwayat: antre.filter(cocok), offline: true };
  }
}

/** Satu hasil latihan lengkap. */
export async function ambilRiwayat(id) {
  const lokal = [...store.get(DEMO, []), ...store.get(ANTREAN, [])].find(r => r.id === id);
  if (lokal || MODE_DEMO) return lokal || null;
  const res = await fetch('/api/riwayat/' + encodeURIComponent(id), { credentials: 'same-origin' });
  if (!res.ok) throw new Error(res.status === 404 ? 'Hasil latihan tidak ditemukan.' : 'Gagal memuat hasil latihan.');
  return res.json();
}

